import { ViewportCell } from '../layout/types';
import PanelTile from '../tile/PanelTile';
import DraggableCell from './DraggableCell';
import { GridPanel } from './GridPanel';
import { RowHost } from './RowHost';

interface DraggablePanelCellProps {
    cell: ViewportCell;
    panel: GridPanel;
    /** The pane's 0-based address, for its accessible name and its drop rule. */
    rowIndex: number;
    columnIndex: number;
    host: RowHost;
}

/**
 * One panel pane of a bound row: the panel in its tile, draggable by its
 * title bar to reorder within the row, and a drop target for its row's
 * other panes.
 */
export default function DraggablePanelCell({
    cell,
    panel,
    rowIndex,
    columnIndex,
    host,
}: DraggablePanelCellProps) {
    return (
        <DraggableCell
            cell={cell}
            name={panel.title}
            rowIndex={rowIndex}
            columnIndex={columnIndex}
            host={host}
        >
            {(dragHandleProps) => (
                <PanelTile
                    title={panel.title}
                    subject={panel.subject}
                    actions={panel.actions}
                    isActive={host.activeId === cell.id}
                    onMaximize={() => host.onToggleMaximize(cell.id)}
                    dragHandleProps={dragHandleProps}
                >
                    {panel.body({ maximized: false })}
                </PanelTile>
            )}
        </DraggableCell>
    );
}
